import { render } from "./NotificationSystem.vue?vue&type=template&id=ef3727ec&scoped=true"
import script from "./NotificationSystem.vue?vue&type=script&lang=js"
export * from "./NotificationSystem.vue?vue&type=script&lang=js"

import "./NotificationSystem.vue?vue&type=style&index=0&id=ef3727ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3727ec"]])

export default __exports__